//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import React from 'react';
import { useFormContext } from 'react-hook-form';
import styled from 'styled-components';

import { CampaignRequest } from '@apis/campaign-requests/shared/CampaignRequests';
import { CAMPAIGN_REQUEST_FORM_VALIDATION } from '@campaigns/constants/CampaignRequestFormValidationConstants';
import { CAMPAIGN_REQUEST_CURRENCIES } from '@campaigns/constants/CampaignRequestsCurrencyConstants';
import { CAMPAIGNS_TRACKING_ID } from '@campaigns/constants/CampaignsTrackingId';
import { BodyText } from '@components/atoms/text/Text';
import { FormFieldController } from '@components/form/field-controller/FormFieldController';
import DropdownSelect from '@components/molecules/dropdown-select/DropdownSelect';

export const CampaignRequestCurrencyField = () => {
  const { control } = useFormContext<CampaignRequest>();

  return (
    <div>
      <BodyText>Currency</BodyText>
      <FormFieldController
        control={control}
        name='currency'
        rules={CAMPAIGN_REQUEST_FORM_VALIDATION.currency}
      >
        {(props) => {
          return (
            <>
              <StyledDropdownSelect
                handleSelect={props.onChange}
                items={CAMPAIGN_REQUEST_CURRENCIES}
                trackingId={
                  CAMPAIGNS_TRACKING_ID.CREATE_CAMPAIGN_CURRENCY_INPUT
                }
                value={props.value}
              />
            </>
          );
        }}
      </FormFieldController>
    </div>
  );
};

const StyledDropdownSelect = styled(DropdownSelect)`
  width: 110px;
  margin-top: ${({ theme }) => theme.spacings[1]};
`;
